import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface BulkUsersState {
  unSavedDataChanges: boolean;
  openUnsavedModal: boolean;
  handleDrawerOpen: boolean;
}

const initialState: BulkUsersState = {
  unSavedDataChanges: false,
  openUnsavedModal: false,
  handleDrawerOpen: false,
};

const bulkUsersSlice = createSlice({
  name: 'bulkUser',
  initialState,
  reducers: {
    setUnSavedChanges(state, action: PayloadAction<boolean>) {
      state.unSavedDataChanges = action.payload;
    },
    setOpenUnsavedModal(state, action: PayloadAction<boolean>) {
      state.openUnsavedModal = action.payload;
    },
    setHandleDrawerOpen(state, action: PayloadAction<boolean>) {
      state.handleDrawerOpen = action.payload;
    },
  },
});

export const {setUnSavedChanges, setOpenUnsavedModal, setHandleDrawerOpen} =
  bulkUsersSlice.actions;

export default bulkUsersSlice.reducer;
